import { render } from "./CampoAdicionalRenderer.vue?vue&type=template&id=1626bc8c"
import script from "./CampoAdicionalRenderer.vue?vue&type=script&lang=js"
export * from "./CampoAdicionalRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__